module.exports = "pegasus_template/assets/circle-google.gif";